import { LobbyImage } from '@colonist/types';
import { getLobbyImagePath } from '../ui_utils/Utils.ts';
export function toOverviewStats(data) {
    return {
        totalGames: String(data.gameData.totalGames),
        winPercent: data.gameData.winPercent,
        pointsPerGame: data.gameData.pointsPerGame,
        karma: data.karma,
        pointsInLast100Games: String(data.gameData.pointsInLast100Games)
    };
}
const TOURNAMENT_CC25_WINNER_ID = '7735637';
const SEASON_11_TOURNAMENT_WINNER_ID = '19719305';
const TOURNAMENT_4P_WINNER_IDS = [
    '3208020',
    '94451747',
    '56604020',
    '51304747',
    '96441641',
    '61890847',
    '55031713',
    '99019802',
    '52067869',
    '99218961',
    '99247781',
    '66028376',
    '98791974',
    '61751886',
    '99200482',
    '98719794',
    '96620362',
    '57772422',
    '23034368',
    '59201781',
    '29049792',
    '61557587',
    '69054281',
    '85708590',
    '90997704',
    '54219086',
    '92602114',
    '96622700',
    '8770469',
    '7735637',
    '100621319',
    '100939283',
    '29911838',
    '18910613',
    '99285407',
    '99822064',
    '101290199',
    '17600804',
    '19374179',
    '99141635',
    '89711215',
    '87958833',
    '48433699',
    '100681011',
    '54365173',
    '19630401',
    '100931185',
    '102303207',
    '101762213',
    '98899185',
    '47836044',
    '100978327',
    '62826207',
    '8041134',
    '101493654',
    '97799211',
    '54314828',
    '102189971'
];
export function toOverviewBadges(userId) {
    const badges = [];
    if (userId == TOURNAMENT_CC25_WINNER_ID) badges.push({
        image: getLobbyImagePath(LobbyImage.TournamentCC25),
        tooltipText: {
            key: 'strings:profilePage.overview.badges.tournamentCC25Tooltip'
        }
    });
    if (userId == SEASON_11_TOURNAMENT_WINNER_ID) badges.push({
        image: getLobbyImagePath(LobbyImage.TournamentS11First),
        tooltipText: {
            key: 'strings:profilePage.overview.badges.season11TournamentFirstTooltip'
        }
    });
    if (TOURNAMENT_4P_WINNER_IDS.includes(userId)) badges.push({
        image: getLobbyImagePath(LobbyImage.Tournament4P),
        tooltipText: {
            key: 'strings:profilePage.overview.badges.tournament4pTooltip'
        }
    });
    return badges;
}
